import "./FooterComponent.scss";

interface FooterComponentProps {
    className?: string;
}

const FooterComponent = (props: FooterComponentProps) => {
    const { className } = props;
    return (
        <div className={'footer-component ' + className}>
            © 2025 Super Engineer AI
        </div>
    );

};

export default FooterComponent;
